export const TrendingUpIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0212 10.208V7.29199L11.9089 12.3984C11.3148 12.9917 10.3521 12.9909 9.75849 12.3975L7.60322 10.2422C7.54629 10.1853 7.45413 10.1853 7.39716 10.2422L2.77802 14.8613C2.50954 15.1298 2.07385 15.1298 1.80537 14.8613C1.53688 14.5928 1.53688 14.1572 1.80537 13.8887L6.42451 9.26953C7.01844 8.6757 7.98197 8.67567 8.57588 9.26953L10.7311 11.4248C10.7881 11.4816 10.8803 11.4816 10.9372 11.4248L16.0573 6.3125H13.1247C12.7452 6.31232 12.4372 6.00459 12.4372 5.625C12.4372 5.24541 12.7452 4.93768 13.1247 4.9375H17.7087C18.0882 4.93768 18.3962 5.24541 18.3962 5.625V10.208C18.3962 10.5876 18.0882 10.8953 17.7087 10.8955C17.329 10.8955 17.0212 10.5877 17.0212 10.208Z"
      fill="currentColor"
    />
  </svg>
);
